// Protocol constants — all values are immutable

export const VERSION = 0x01;
export const MSG_SIZE = 2048;
export const NONCE_SIZE = 16;
export const TAG_SIZE = 32;
export const SIG_SIZE = 64;
export const PUBKEY_SIZE = 32;
export const POW_BITS = 16;
export const HEAD_WINDOW = 3;
export const AEAD_NONCE_SIZE = 24;
